(function($) {
  'use strict';
  
  // Fire on document ready.
  $( document ).ready( function() {

    /***
    * BEGIN HEADER SEARCH FORM LOGIC
    */
    var $search_form = $('.search-form-wrapper .search-form'),
        $input_container = $('.search-form-wrapper .input-container'),
        $input = $(".search-form-wrapper input.search-field"),
        search_query = ($input.length > 0) ? $input.val().trim() : '';

    // show initial search input value, if it is an active search
    if( search_query !== '' && search_query !== undefined ) {
      $input_container.foundation('toggle');
    }

    // intercept click event for search submit button
    $('.search-form-wrapper .search-submit').on('click', function(e) {
      var $input = $(this).parents('.search-form').find('input.search-field'),
          search_query = $input.val().trim(); // use current value

      if( search_query === '' ) {
        e.preventDefault();
      } else {
        e.stopPropagation();
      }

    });

    $input_container.on('on.zf.toggler', function(e) {
        // use local elements
        var $search_form = $(this).parents('.search-form'),
            $input = $search_form.find('input.search-field');

        $input.focus();
        $search_form.addClass('active');
    });

    $input_container.on('off.zf.toggler', function(e) {
        // use local elements
        var $search_form = $(this).parents('.search-form'),
            $input = $search_form.find('input.search-field');

          console.log('off toggled');

        $input.blur();
        $input.val('');
        $search_form.removeClass('active');
    });

    // custom close trigger using toggler
    $('.search-form .close-button').on('click', function(e) {

      // use local elements
      var $input_container = $(this).parents('.input-container');

      e.preventDefault();
      $input_container.foundation('toggle');
      //$input.val('');
    });

    // hide and clear input on body click
    $(document).on('keydown', function(e) {

      if( e.keyCode == 27 && $input_container.filter(':visible').length > 0 ) {
        //console.log($input_container);
        $input_container.foundation('toggle');
      }

    });

    $('.header-sticky').on('sticky.zf.stuckto:top sticky.zf.unstuckfrom:top', disableSearchInputs);
    //$('.header-sticky').on('sticky.zf.unstuckfrom:top', disableSearchInputs);
    
    function disableSearchInputs(e) {
      //console.log('sticky un/stuck');

      // only do this for desktop nav
      if ( ! Foundation.MediaQuery.atLeast('large') ) {
        return;
      }
      
      // disable active search inputs
      $input_container.each(function(i, elem) {
        var $search_form = $(this).parents('.search-form');
        if( ! $search_form.hasClass('active') ) return;
        $(this).foundation('toggle');
      });
    }

    /* END HEADER SEARCH FORM LOGIC */

  });

})( jQuery );
